export default "__VITE_ASSET__fbcf044b__"